import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { getAllValue, hasMixedValues, hasDefinedValues } from './utils';
export default function AllInputControl(_ref) {
  let {
    onChange,
    values,
    ...props
  } = _ref;
  const allValue = getAllValue(values);
  const hasValues = hasDefinedValues(values);
  const isMixed = hasValues && hasMixedValues(values);
  const allPlaceholder = isMixed ? __('Mixed') : null;
  return createElement(UnitControl, _extends({}, props, {
    "aria-label": __('Border radius'),
    disableUnits: isMixed,
    isOnly: true,
    value: allValue,
    onChange: onChange,
    placeholder: allPlaceholder
  }));
}
//# sourceMappingURL=all-input-control.js.map